<template>
  <div class="container-fluid">
    <div class="d-flex">
      <h1 class="mr-auto">Обзор <small class="text-muted">за последние 7 дней</small></h1>
      <template v-if="$root.canSelectRegion()">
        <h2 class="mr-1 mt-1 align-self-center">Организация:</h2>
        <div class="col-md-4 pr-0">
        <server-select
          v-model="selectedRegion"
          label="name"
          endpoint="regions/options"
          class="my-1 ml-1"
          :multiple="true"
          :searchable="false"
          :lazy="true"
          placeholder="Выберите..."
        />
        </div>
      </template>
    </div>
    <div class="row mb-4">
      <div class="col-md-4">
        <div class="card h-100">
          <h3 class="card-header"><span class="text-caps">График продаж</span></h3>
          <div class="card-body d-flex align-items-center px-0">
            <graph
              class="w-100"
              endpoint="machines/sales"
              :endpoint-params="this.endpointParams"
              period="week"
              :height="270"
              :data.sync="graphData"
            ></graph>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Продажи</span></h3>
          <div class="ml-3 flex-grow-1">
            <table class="table table-index-sales table-head-light w-100 table-sm px-0 mb-0" style="height: 250px; table-layout: fixed;" v-if="sales">
              <thead>
              <tr>
                <th>День недели</th>
                <th class="text-right">Количество</th>
                <th width="150" class="text-right pr-5">Сумма</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sale in sales">
                <td style="text-transform: capitalize;">{{sale.dayOfWeek}}</td>
                <td class="text-right"><strong><number :number="sale.count "/></strong></td>
                <td class="text-right pr-5"><number :number="sale.sum "/></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_sales')">
            <router-link to="/reports/sales">Подробнее…</router-link>
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex flex-column">
        <div class="card">
          <h3 class="card-header"><span class="text-caps">На связи</span></h3>
          <div class="card-body">
            <div v-if="machinesStatus">
              <div class="d-flex align-items-center my-3 mx-2">
                <div class="text-large">{{Math.round((machinesStatus.online * 100) / machinesStatus.total)}} %</div>
                <div class="progress flex-grow-1 mx-3">
                  <div class="progress-bar" role="progressbar"
                    :style="'width:'+((machinesStatus.online*100) / machinesStatus.total)+ '%;'"
                    :aria-valuenow="machinesStatus.online" aria-valuemin="0"
                    :aria-valuemax="machinesStatus.total">
                  </div>
                  <!--<span class="mx-auto">{{ Math.round(100 - Math.round((machinesStatus.online * 100) / machinesStatus.total))}}%</span>-->
                </div>
                <div class="text-large"><strong>{{machinesStatus.online}}</strong> из {{machinesStatus.total}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4 flex-grow-1">
          <div class="col-md-6">
            <div class="card h-100">
              <h3 class="card-header"><span class="text-caps">Купюры</span></h3>
              <div v-if="stats" class="card-body d-flex flex-column justify-content-around">
                <div class="mb-2">Купюр в автоматах <br><strong class="text-large"><number :number="stats.banknotes.sum"/> руб.</strong></div>
                <div class="mb-2">Требуют инкассации <br><strong class="text-large"><number :number="stats.banknotes.count "/></strong></div>
                <router-link to="/reports/encashment" v-if="$root.checkPermission('web_collect')">Подробнее…</router-link>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100">
              <h3 class="card-header"><span class="text-caps">Монеты</span></h3>
              <div v-if="stats" class="card-body d-flex flex-column justify-content-around">
                <div class="mb-2">Монет на сдачу <br><strong class="text-large"><number :number="stats.coins.sum "/> руб.</strong></div>
                <div class="mb-2">Требуют загрузки <br><strong class="text-large"><number :number="stats.coins.count "/></strong></div>
                <router-link to="/reports/encashment" v-if="$root.checkPermission('web_collect')">Подробнее…</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row mb-4">
      <div class="col-md-4">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Простои</span></h3>
          <div class="ml-3 flex-grow-1">
            <table class="table table-head-light w-100 h-100 table-sm px-0 mb-0" v-if="downtimes">
              <thead>
              <tr>
                <th>Организация</th>
                <th class="text-right">Суммарный простой</th>
                <th class="text-right pr-3">Автоматов с простоями</th>
              </tr>
              </thead>
              <tr v-for="downtime in downtimes" :class="{'text-muted': !(downtime.sum || downtime.count)}">
                <td>{{downtime.name}}</td>
                <td class="text-right">{{downtime.sum | formatDowntimesDuration}}</td>
                <td class="text-right pr-3"><number :number="downtime.count "/></td>
              </tr>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_downtime')">
            <router-link to="/reports/downtime">Подробнее…</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Несоблюдение плана обслуживания</span></h3>
          <div class="ml-3 flex-grow-1">
          <table class="table table-head-light w-100 h-100 table-sm px-0 mb-0" v-if="deviations">
              <thead>
              <tr>
                <th>Организация</th>
                <th class="text-right">Отклонений</th>
                <th class="text-right pr-3">Кол-во автоматов</th>
              </tr>
              </thead>
              <tr v-for="(deviation) in deviations" :class="{'text-muted': !(deviation.sum || deviation.count)}">
                <td>{{deviation.name}}</td>
                <td class="text-right"><number :number="deviation.sum "/></td>
                <td class="text-right pr-3"><number :number="deviation.count "/></td>
              </tr>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_service')">
            <router-link to="/service">Подробнее…</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card h-100 d-flex">
          <h3 class="card-header flex-grow-0"><span class="text-caps">Инкассации</span></h3>
          <div class="ml-3 flex-grow-1">
            <table class="table table-head-light w-100 h-100 table-sm px-0 mb-0" style="table-layout: fixed;" v-if="encashment">
              <thead>
              <tr>
                <th>Организация</th>
                <th class="text-right">Общая сумма</th>
                <th class="text-right pr-3">Несвоевременных</th>
              </tr>
              </thead>
              <tr v-for="index in encashment" :class="{'text-muted': !(index.sum || index.count)}">
                <td>{{index.name}}</td>
                <td class="text-right"><number :number="index.sum "/></td>
                <td class="text-right pr-3"><number :number="index.count "/></td>
              </tr>
            </table>
          </div>
          <div class="card-body flex-grow-0" v-if="$root.checkPermission('web_collect')">
            <router-link to="/reports/encashment">Подробнее…</router-link>
          </div>
        </div>
      </div>
    </div> -->

    <h2>Автоматы, требующие обслуживания</h2>
    <div v-if="machines">
      <div class="card mb-5">
        <div class="card-header">
          <div class="row">
            <div class="col-md-5"><strong>Организация</strong></div>
            <div class="col-md-7"><strong>Количество автоматов, требующих обслуживания</strong></div>
          </div>
        </div>
        <div id="machines-accordion" role="tablist" aria-multiselectable="true">
          <div v-for="(region, name, i) in machines" class="border-bottom">
            <a
              class="btn btn-lg btn-block text-body text-left"
              :class="Object.keys(machines).length === 1 ? '' : 'collapsed'"
              data-toggle="collapse"
              data-parent="#machines-accordion"
              :href="'#collapse'+i"
              aria-expanded="true"
              :aria-controls="`collapse${i}`"
              role="tab"
              :id="`heading${i}`"
            >
              <h5 class="mb-0">
                <div class="row">
                  <div class="col-md-5">{{name}}</div>
                  <div class="col-md-7">{{region.length}}</div>
                </div>
              </h5>
            </a>
            <div
              :id="`collapse${i}`"
              class="collapse"
              :class="Object.keys(machines).length === 1 ? 'show' : ''"
              role="tabpanel"
              :aria-labelledby="`heading${i}`"
            >
              <table class="table mb-0">
                <thead>
                <tr>
                  <th width="100">№ автомата</th>
                  <th width="180">Состояние</th>
                  <th width="220">Посл. обслуживание</th>
                  <th>Место установки</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="machine in region">
                  <td>
                    <router-link :to="`/machines/${machine.id}`" v-if="$root.checkPermission('web_ta_main')">
                      {{machine.serial_number}}
                    </router-link>
                    <div v-else>
                      {{machine.serial_number}}
                    </div>
                  </td>
                  <td><status-images :value="machine.status" :reasons="machine.downtimes_reasons"></status-images></td>
                  <td>{{machine.last_service_at | formatDate}}</td>
                  <td>{{machine.address}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import tail from 'lodash/tail'
  import zip from 'lodash/zip'
  import moment from 'moment'
  import api from '@/api'

  export default {
    metaInfo: {title: 'Обзор'},
    data () {
      return {
        city: null,
        graphData: null,
        selectedRegion: [],
      }
    },
    computed: {
      sales () {
        if (!this.graphData) return []
        return tail(zip(this.graphData.values, this.graphData.sales, this.graphData.revenue, this.graphData.before_sales, this.graphData.before_revenue))
          .map((day) => ({
            dayOfWeek: moment(day[0]).format('dddd'),
            count: day[1] + day[3],
            sum: day[2] + day[4],
          }))
      },
      endpointParams () {
        return {
          regions: this.selectedRegion.map(e => e.id),
        }
      }
    },
    asyncComputed: {
      machinesStatus () {
        let data = {params: this.endpointParams}
        return api.get(`index/status`, data).then(({data}) => data.data)
      },
      encashment () {
        let data = {params: this.endpointParams}
        return api.get(`index/encashment`, data).then(({data}) => data.data)
      },
      machines () {
        let data = {params: this.endpointParams}
        return api.get(`index/machines`, data).then(({data}) => data.data)
      },
      downtimes () {
        let data = {params: this.endpointParams}
        return api.get(`index/downtimes`, data).then(({data}) => data.data)
      },
      deviations () {
        let data = {params: this.endpointParams}
        return api.get(`index/deviations`, data).then(({data}) => data.data)
      },
      stats () {
        let data = {params: this.endpointParams}
        return api.get(`index/stats`, data).then(({data}) => data.data)
      },
    },
    filters: {
      formatDowntimesDuration (seconds) {
        if (!seconds) return seconds
        return Math.round(seconds / 60 / 60 / 24) + ' дн.'
      },
    },
  }
</script>

<style lang="scss">
  .table-index-sales {
    td, th {
      vertical-align: middle;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/index.vue